import BreadcrumbSection from "~/layout/public/bread-crumbs/bread-crumb-section";
import CoursesSection from "~/components/pages/courses/courses-section";
import type { Route } from "./+types/type";
import { getTitleTemplate, canonical } from "~/utils/meta";
import { formatCourseTypeTitle, formatSlugTitle } from "~/utils/strings";
import { defaultMeta, mergeMeta } from "~/lib/meta";




export default function CoursesType({ params }: Route.ComponentProps) {
  const { title, desc } = titleAndDescription(params.ctid);

  return (
    <>
      <BreadcrumbSection title={title} text={desc} />
      <CoursesSection />
    </>
  );
}

export function meta({ matches, params }: Route.MetaArgs) {
  const tpl = getTitleTemplate(matches);
  const ctid = params.ctid ?? "courses";
  const pretty = formatSlugTitle(ctid);         // "health-safety" → "Health & Safety"
  const title = tpl(`${pretty} Courses`);
  const desc = `Explore ${pretty} courses delivered by accredited trainers across the South East.`;
 
  return mergeMeta(
    defaultMeta(),
    [
      { title: title },
      { name: "description", content: desc },
      { property: "og:title", content: title },
      { property: "og:description", content: desc },
      { property: "og:url", content: canonical(`/courses/${ctid}`) },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: desc },
      { tagName: "link", rel: "canonical", href: canonical(`/courses/${ctid}`) },
      // add canonical as a <link> via your links() export separately
    ]
  );
}

function titleAndDescription(ctid: string) {
  const pretty = formatSlugTitle(ctid);
  let title = `${pretty} Courses`;
  let desc = `Explore ${pretty} courses delivered by accredited trainers across the South East.`;

  switch (ctid) {
    case 'first-aid':
      title = `First Aid Training Courses for Workplaces`;
      desc = `Explore First Aid courses delivered by accredited trainers across the UK.`;
      break;
    case 'mental-health-first-aid':
      title = `Mental Health First Aid (MHFA) Training`;
      desc = `Explore Mental Health First Aid courses delivered by accredited trainers across the UK.`;
      break;
    case 'health-safety':
      title = `Health & Safety Training Courses`;
      desc = `Explore Health & Safety courses delivered by accredited trainers across the UK.`;
      break;
  }

  return { title, desc };
} 